// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradePartnerDevelopmentContractsQueryVariables = Types.Exact<{
  tradePartnerId: Types.Scalars['ID']['input'];
}>;


export type TradePartnerDevelopmentContractsQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, bidContracts: Array<{ __typename?: 'BidContract', id: string, isPrimary?: boolean | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, latestRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string, name: string }>, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string } } }> }> };

export type TradePartnerDevelopmentContractFragment = { __typename?: 'BidContract', id: string, isPrimary?: boolean | null | undefined, developments: Array<{ __typename?: 'Development', id: string, name: string }>, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, latestRevision: { __typename?: 'BidContractRevision', id: string, version: string, startDate: Types.Scalars['Date']['input'], endDate?: Types.Scalars['Date']['input'] | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, number: string, name: string }>, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string } } };

export const TradePartnerDevelopmentContractFragmentDoc = gql`
    fragment TradePartnerDevelopmentContract on BidContract {
  id
  isPrimary
  developments {
    ...Named
  }
  projects {
    ...Named
  }
  latestRevision {
    id
    version
    costCodes {
      id
      number
      name
    }
    status {
      code
      name
    }
    startDate
    endDate
  }
}
    ${NamedFragmentDoc}`;
export const TradePartnerDevelopmentContractsDocument = gql`
    query TradePartnerDevelopmentContracts($tradePartnerId: ID!) {
  tradePartners(filter: {id: [$tradePartnerId]}) {
    id
    name
    bidContracts {
      ...TradePartnerDevelopmentContract
    }
  }
}
    ${TradePartnerDevelopmentContractFragmentDoc}`;

/**
 * __useTradePartnerDevelopmentContractsQuery__
 *
 * To run a query within a React component, call `useTradePartnerDevelopmentContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradePartnerDevelopmentContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradePartnerDevelopmentContractsQuery({
 *   variables: {
 *      tradePartnerId: // value for 'tradePartnerId'
 *   },
 * });
 */
export function useTradePartnerDevelopmentContractsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables> & ({ variables: TradePartnerDevelopmentContractsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>(TradePartnerDevelopmentContractsDocument, options);
      }
export function useTradePartnerDevelopmentContractsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>(TradePartnerDevelopmentContractsDocument, options);
        }
// @ts-ignore
export function useTradePartnerDevelopmentContractsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>;
export function useTradePartnerDevelopmentContractsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradePartnerDevelopmentContractsQuery | undefined, TradePartnerDevelopmentContractsQueryVariables>;
export function useTradePartnerDevelopmentContractsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>(TradePartnerDevelopmentContractsDocument, options);
        }
export type TradePartnerDevelopmentContractsQueryHookResult = ReturnType<typeof useTradePartnerDevelopmentContractsQuery>;
export type TradePartnerDevelopmentContractsLazyQueryHookResult = ReturnType<typeof useTradePartnerDevelopmentContractsLazyQuery>;
export type TradePartnerDevelopmentContractsSuspenseQueryHookResult = ReturnType<typeof useTradePartnerDevelopmentContractsSuspenseQuery>;
export type TradePartnerDevelopmentContractsQueryResult = Apollo.QueryResult<TradePartnerDevelopmentContractsQuery, TradePartnerDevelopmentContractsQueryVariables>;